import React from 'react';
import Card from '../Card/Card';

function StatCard({ label, value, helper, variant = 'neutral' }) {
  return (
    <Card compact className={`custom-stat-card custom-stat-card--${variant}`}>
      <span className="custom-stat-card__main">
        <span className="custom-stat-card__label">{label}</span>
        <strong className="custom-stat-card__value">{value}</strong>
      </span>
      {helper && <small className="custom-stat-card__helper">{helper}</small>}
    </Card>
  );
}

export default StatCard;
